export const CLEAR_SPECIFIC_CMSPAGES = 'CLEAR_SPECIFIC_CMSPAGES';

export default function clearSpecificCmsPages(urls: string[]) {
  return {
    type: CLEAR_SPECIFIC_CMSPAGES,
    payload: urls,
  };
}